<template>
  <div
    class="create-mode-switch flex"
    :class="{
      [`create-mode-switch--${createRenderType}`]: true,
      ['create-mode-switch-guid--visible']:
        !props.isSimilar &&
        createModeClickedStateVisible &&
        (createRenderType == 'pc' ||
          ['max', 'playermax'].includes(create_createEditOpenState)),
    }"
  >
    <div class="create-mode-switch-guid-mask"></div>
    <div
      class="create-mode-switch"
      :class="{
        'create-mode-switch--hover': renderData.createEditModeHover,
      }"
    >
      <div
        class="create-mode-switch-item pointer flex-center"
        ref="refCreateEditBasic"
        :class="{
          'create-mode-switch-item--active': createEditMode == 'easy',
          'create-mode-switch-item--breath':
            createEditModelBreath &&
            createEditMode != 'easy' &&
            !createEditGuidTourVisible,
        }"
        @mouseover="
          () => {
            if (createEditMode != 'easy') {
              setCreateEditModeHover('easy');
            } else {
              setCreateEditModeHover('');
            }
          }
        "
        @mouseleave="
          () => {
            setCreateEditModeHover('');
          }
        "
        @click="
          () => {
            setCreateEditMode('easy');
          }
        "
      >
        <div class="create-mode-switch-item-content">
          <span class="olh"> {{ $$t("create.easy_mode") }} </span>

          <i v-if="createEditModelBreath && createEditMode != 'easy'"> </i>
        </div>
        <div
          class="create-mode-switch-item-guid create-mode-switch-item-guid--easy"
          v-if="createEditMode != 'easy'"
        >
          <p class="create-mode-switch-item-guid-desc">
            {{ $$t("create.easy_mode_guid_desc") }}
          </p>
          <!-- <div class="create-mode-switch-item-guid-btn">
            <Button
              :renderStyle="{
                '--padding': '0 10px',
                '--width': '100%',
                '--height': '40px',
                '--borderRadius': '40px',
                '--background': 'rgba(255, 255, 255, 1)',
                '--fontColor': '#000',
                '--fontSize': '14px',
                '--fontWeight': '500',
                '--border': 'none',
                '--backgroundHover': 'rgba(255, 255, 255, 0.75)',
                '--fontColorHover': '#000',
              }"
              @click="onGotIt"
            >
              <span>{{ $$t("create.try_it_now") }}</span>
            </Button>
          </div> -->
        </div>
      </div>
      <div
        @mouseover="
          () => {
            if (createEditMode != 'hard') {
              setCreateEditModeHover('hard');
            } else {
              setCreateEditModeHover('');
            }
          }
        "
        @mouseleave="
          () => {
            setCreateEditModeHover('');
          }
        "
        ref="refCreateEditAdvanced"
        class="create-mode-switch-item pointer flex-center"
        :class="{
          'create-mode-switch-item--active': createEditMode == 'hard',
          'create-mode-switch-item--breath':
            createEditModelBreath && createEditMode != 'hard',
        }"
        @click="
          () => {
            setCreateEditMode('hard');
          }
        "
      >
        <div class="create-mode-switch-item-content">
          <span class="olh">{{ $$t("create.advanced_mode") }} </span>
          <i v-if="createEditModelBreath && createEditMode != 'hard'"> </i>
        </div>
        <div
          class="create-mode-switch-item-guid create-mode-switch-item-guid--hard"
          v-if="createEditMode != 'hard'"
        >
          <p class="create-mode-switch-item-guid-desc">
            {{ $$t("create.advanced_mode_guid_desc") }}
          </p>
          <!-- <div class="create-mode-switch-item-guid-btn">
            <Button
              :renderStyle="{
                '--padding': '0 10px',
                '--width': '100%',
                '--height': '40px',
                '--borderRadius': '40px',
                '--background': 'rgba(255, 255, 255, 1)',
                '--fontColor': '#000',
                '--fontSize': '14px',
                '--fontWeight': '500',
                '--border': 'none',
                '--backgroundHover': 'rgba(255, 255, 255, 0.75)',
                '--fontColorHover': '#000',
              }"
              @click="onGotIt"
            >
              <span>{{ $$t("create.try_it_now") }}</span>
            </Button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue";
import { storeToRefs } from "pinia";

import Button from "@/components/basic/button/Button.vue";

import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useUserDataStore from "@/store/userDataStore.js";
import useGlobalUserStateStore from "@/store/globalUserStateStore.js";

const userDataStore = useUserDataStore();
const createLayoutStore = useCreateLayoutStore();
const globalUserStateStore = useGlobalUserStateStore();

const {
  createEditMode,
  createRenderType,
  createEditModelBreath,
  createEditGuidTourVisible,
  create_createEditOpenState,
} = storeToRefs(createLayoutStore);
const { createModeClickedStateVisible } = storeToRefs(globalUserStateStore);

const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const props = defineProps({
  isSimilar: {
    type: Boolean,
    default: false,
  },
});
const emits = defineEmits([]);
const refCreateEditBasic = ref(null);
const refCreateEditAdvanced = ref(null);
const renderData = reactive({
  createEditModeHover: "",
});

const onGotIt = () => {
  setCreateEditMode();
};

const setCreateEditModeHover = (val) => {
  renderData.createEditModeHover = val;
};

const setCreateEditMode = (type) => {
  setCreateEditModeHover("");
  const globalProperties =
  (getCurrentInstance() || (window?.$getVueCurrentInstance?.())).appContext?.config?.globalProperties;
  const isGuid = !props.isSimilar && createModeClickedStateVisible.value;
  if (createEditMode.value == "hard" && type == "easy") {
    createLayoutStore.setCreateEditMode("easy", isGuid);
    globalProperties?.logClickEvent("create_basic_mode", {
      type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
      tab_stare: isGuid ? "guide_switch" : "switch",
      is_similar: props.isSimilar ? "true" : "false",
    });
    if (!props.isSimilar) {
      globalUserStateStore.reportCreateModeClickedState("easy");
    }
  } else if (createEditMode.value == "easy" && type == "hard") {
    createLayoutStore.setCreateEditMode("hard", isGuid);
    globalProperties?.logClickEvent("create_advanced_mode", {
      type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
      tab_stare: isGuid ? "guide_switch" : "switch",
      is_similar: props.isSimilar ? "true" : "false",
    });
    if (!props.isSimilar) {
      globalUserStateStore.reportCreateModeClickedState("hard");
    }
  }
  createLayoutStore.setCreateEditModelBreath(false);
};

watch(
  () => {
    return userDataStore.isLogin;
  },
  () => {
    nextTick(() => {
      if (userDataStore.isLogin) {
        if (!props.isSimilar) {
          globalUserStateStore.reportCreateModeClickedState(
            createLayoutStore.createEditMode
          );
        }
      }
    });
  }
);
onMounted(() => {
  globalUserStateStore.reportCreateModeClickedState(
    createLayoutStore.createEditMode
  );
});
</script>
<style lang="scss">
@keyframes animation-breath {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  10% {
    opacity: 1;
    transform: scale(1.1);
  }
  20% {
    opacity: 1;
    transform: scale(1);
  }
  30% {
    opacity: 1;
    transform: scale(1.1);
  }
  40% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.1);
  }
  60% {
    opacity: 1;
    transform: scale(1);
  }
  60% {
    animation-play-state: paused;
  }
  100% {
    animation-play-state: running;
  }
}

.create-mode-switch {
  align-items: center;
  justify-content: start;
  max-width: 100%;

  .create-mode-switch-guid-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(10px);
    display: none;
  }
  .create-mode-switch-item-guid {
    position: absolute;
    top: 60px;
    left: -50%;
    width: 245px;
    padding: 16px 20px;
    background: #94adff;
    border-radius: 12px;
    display: none;
    .create-mode-switch-item-guid-desc {
      font-family: HarmonyOS Sans SC;
      font-size: 20px;
      font-weight: bold;
      line-height: 26px;
      color: #ffffff;
    }
    .create-mode-switch-item-guid-btn {
      margin-top: 12px;
    }
    &:before {
      content: "";
      position: absolute;
      top: -28px;
      left: 50%;
      height: 40px;
      width: 35px;
      background-image: url("@/assets/img/click-ico.png");
      background-size: 100% 100%;
      transform: translateX(-17.5px);
    }
    &.create-mode-switch-item-guid--easy {
      left: 0;
      width: 168px;
      &:before {
        left: 30%;
        transform: translateX(-1px);
      }
    }
  }
  &.create-mode-switch-guid--visible {
    position: relative;
    z-index: 1;
    .create-mode-switch-guid-mask {
      // display: block;
    }
    .create-mode-switch-item-guid {
      display: block;
    }
  }

  .create-mode-switch {
    display: none;
    flex-direction: row;
    align-items: center;
    padding: 2px;
    border-radius: 56px;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(20px);
    display: flex;
    &.create-mode-switch--hover {
      background: rgba(255, 255, 255, 0.2);
    }
    .create-mode-switch-item {
      font-family: HarmonyOS Sans SC;
      position: relative;
      z-index: 2;
      font-size: 15px;
      font-weight: normal;
      line-height: 34px;
      text-align: center;
      color: #ffffff;
      border-radius: 56px;
      width: 50%;
      .create-mode-switch-item-content {
        position: relative;
        padding: 0 8px;
        max-width: 100%;
        span {
          max-width: 100%;
          display: block;
        }
      }
      &.create-mode-switch-item--breath {
        animation: animation-breath 3s ease infinite;
        i {
          position: absolute;
          right: -8px;
          top: 4px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #ff6464;
        }
        span {
          display: inline-block;
          transform-origin: center;
        }
      }
      &.create-mode-switch-item--active {
        background: #ffffff;
        font-weight: 500;
        color: #000000;
      }
    }
  }
  &.create-mode-switch--mobile {
    .create-mode-switch-mb-item {
      line-height: 32px;
      font-size: 14px;
      width: 120px;
      position: relative;
      .create-mode-switch-item-content {
        position: relative;
      }
      &.create-mode-switch-item--breath {
        animation: animation-breath 3s ease infinite;
        i {
          position: absolute;
          right: -8px;
          top: 4px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #ff6464;
        }
        span {
          display: inline-block;
        }
      }
    }
    .create-mode-switch {
      display: flex;
    }
  }
}
</style>
